<template>
  <b-container class="p-main-container">
    <div class="p-buttons-wrap">
      <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
      <b-button variant="info" @click="print">Print Profile</b-button>
      <b-button variant="info" @click="edit">Edit Profile</b-button>

      <!-- <button v-print="'#printMe'">Print Application</button> -->
    </div>

    <div id="printme">
      <div class="application-view">
        <div></div>
        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row">
              <b-row>
                <b-col cols="8" offset="1">
                  <b-container class="bv-example-row">
                    <h5 class="reg-form-title text-primary">Personal Details</h5>
                    <!-- <b-row>
                      <b-col>Application No: {{personalDetails.LoanApplication[0].LoanApplicationNo}}</b-col>
                    </b-row>-->

                    <table class="profile-table table-3x">
                      <tbody>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Applicant Name:</span>
                            {{personalDetails.FirstName}} {{personalDetails.MiddleName}} {{personalDetails.LastName}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{personalDetails.DOB}}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{personalDetails.AdharNo}}
                          </td>
                          <td>
                            <span class="bold">PAN No.:</span>
                            {{personalDetails.PanCardNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Email:</span>
                            {{personalDetails.EmailID}}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{personalDetails.MobileNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Married Status:</span>
                            <span v-if="personalDetails.MaritalStatus">Yes</span>
                            <span v-else>No</span>
                          </td>
                          <td>
                            <span class="bold">Nationality:</span>
                            <span v-if="personalDetails.Nationality">Indian</span>
                            <span v-else>Non-Indian</span>
                          </td>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Ration Card:</span>
                            <span>{{personalDetails.RationCardNo}}</span>
                          </td>
                          <td>
                            <span class="bold">Family Income:</span>
                            <span>{{personalDetails.FamilyIncome}}</span>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            <span>{{personalDetails.CasteName}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-container>
                </b-col>

                <b-col cols="2" offset>
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.UserLoanDocuments.PhotoPath)"
                        >
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.UserLoanDocuments.SignaturePath)"
                        >
                      </b-col>
                    </b-row> -->
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- ******** -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Address Details</h5>

                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">House No:</span>
                          {{personalDetails.CorrespondenceAddress.HouseNo}}
                        </td>
                        <td>
                          <span class="bold">Building No:</span>
                          {{personalDetails.CorrespondenceAddress.BuildingNo}}
                        </td>
                        <td>
                          <span class="bold">Landmark:</span>
                          {{personalDetails.CorrespondenceAddress.Landmark}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">State:</span>
                          {{personalDetails.CorrespondenceAddress.StateName}}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{personalDetails.CorrespondenceAddress.DistrictName}}
                        </td>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{personalDetails.CorrespondenceAddress.TalukaName}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Pincode:</span>
                          {{personalDetails.CorrespondenceAddress.Pincode}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Details</h5>

                  <table class="profile-table">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Bank Accept:</span>
                          {{personalDetails.UserBankDetails.BankAccept}}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{personalDetails.UserBankDetails.BankName}}
                        </td>
                        <td>
                          <span class="bold">Branch Name:</span>
                          {{personalDetails.UserBankDetails.BranchName}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">City:</span>
                          {{personalDetails.UserBankDetails.City}}
                        </td>
                        <td>
                          <span class="bold">Comment:</span>
                          {{personalDetails.UserBankDetails.Comment}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Lending Loan Details</h5>

                  <table class="profile-table">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Institute Name:</span>
                          {{personalDetails.UserLendingLoanDetails.OrganizationName}}
                        </td>
                        <td>
                          <span class="bold">Institute Address:</span>
                          {{personalDetails.UserLendingLoanDetails.OrganizationAddress}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Course:</span>
                          {{personalDetails.UserLendingLoanDetails.ProductfromOrganization}}
                        </td>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{personalDetails.UserLendingLoanDetails.AmountFromBank}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Documents Uploaded</h5>
                  <table class="profile-table doc-table">
                    <tr>
                      <th>Document Type</th>
                      <th>Link</th>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.PhotoPath !=''">
                      <td>Photo</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.PhotoPath)"
                        >View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.SignaturePath !=''" style="display:none">
                      <td>Signature</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.SignaturePath)"
                        >View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.ResidentialProofPath !=''">
                      <td>Residential Proof</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.ResidentialProofPath)"
                        >View</a>
                      </td>
                    </tr>

                    <tr v-if="personalDetails.UserLoanDocuments.AddharCardPath !=''">
                      <td>Adhar Card</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.AddharCardPath)"
                        >View</a>
                      </td>
                    </tr>

                    <tr v-if="personalDetails.UserLoanDocuments.IncomeTaxApplication  !=''" style="display:none">
                      <td>Income Tax Application</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.IncomeTaxApplication)"
                        >View</a>
                      </td>
                    </tr>

                    <tr v-if="personalDetails.UserLoanDocuments.CastCertificate !=''">
                      <td>Cast Certificate</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.CastCertificate)"
                        >View</a>
                      </td>
                    </tr>

                    <tr v-if="personalDetails.UserLoanDocuments.OtherDocument  !=''">
                      <td>Other Document</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.OtherDocument)"
                        >View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.IncomeCertificatePath  !=''">
                      <td>Income Certificate</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.IncomeCertificatePath)"
                        >View</a>
                      </td>
                    </tr>
                     <tr v-if="personalDetails.UserLoanDocuments.RationCardPath  !=''">
                      <td>Ration Card</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.RationCardPath)"
                        >View</a>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.BirthCertificate  !=''">
                      <td>Birth Certificate</td>
                      <td>
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.UserLoanDocuments.BirthCertificate)"
                        >View</a>
                      </td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <!-- Printme id ends here -->
  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import Formatter from "@/Formatter.js";
export default {
  data() {
    return {
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: "",
        Age: 38,
        PlaceOfBirth: "",
        Gender: true,
        MotherName: "",
        MobileNo: "",
        MobileNo1: null,
        LandlineNo: null,
        MaritalStatus: true,
        MotherToungue: true,
        EmailID: "",
        Nationality: true,
        Domiciled: true,
        MotherToung: "Hindi",
        AdharNo: "",
        PanCardNo: "",
        CategoryType: null,
        BoardID: "a1bfdfd8-db30-4d39-87f7-5f2eddd7f810",
        RegistrationType: 2,

        LoginID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: null,
        TotalMarks: 0,
        ResultStatus: null,
        ExServiceMan: false,
        Driving: true,
        JobID: null,
        DeceasedRegNum: null,
        DeceasedName: null,
        DeceasedRelation: null,
        OtherRelationName: "",
        OrderNum: null,
        OrderDate: "2001-01-01T00:00:00",
        CourtName: null,
        PetitionNum: null,
        PetitionDate: "2001-01-01T00:00:00",
        UnionName: null,
        LockProfile: true,
        RegistrationTypeName: "",
        BoardName: "",
        PermanentAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 400612,
          Post: "",
          StateName: "",
          DistrictName: "",
          TalukaName: ""
        },

        CorrespondenceAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 0,
          Post: "",
          ResidanceSince: 1,
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane"
        },
        UserBankDetails: {
          BankAccept: true,
          BankID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          BankName: "",
          BranchName: "",
          City: "",
          Comment: ""
        },
        UserLendingLoanDetails: {
          AmountFromBank: "",
          LoanDistrict: "",
          OrganizationAddress: "",
          OrganizationName: "",
          ProductfromOrganization: "",
          UserLendingLoanID: ""
        },
        UserPhysicalDetails: {
          UserPhysicalID: null,
          IndetificationMark: "",
          Height: 188,
          Weight: 85,
          ChestDeflated: 100,
          ChestInflated: 105
        },
        UserQualification: {
          QualificationTypeID: "09713307-253d-4e35-aca9-50ccde3e05a6",
          DegreeID: "03c001dc-b65e-4b96-bd25-f4e425c7fab6",
          StateID: "6e394345-c136-4618-9258-d3bd530fd97b",
          BoardID: "80d06c9d-8256-4b83-ad87-620debf38d32",
          Result: 1,
          Percentage: 66.0,
          Class: "First Class",
          QualificationType: {
            QualificationTypeID: null,
            QualificationTypeName: "Graduate"
          },
          DegreeType: {
            DegreeTypeID: null,
            DegreeName: "B.A.",
            QaulificaitonTypeID: "00000000-0000-0000-0000-000000000000"
          },
          UserState: {
            StateID: "00000000-0000-0000-0000-000000000000",
            StateName: "Bihar"
          },
          EducationBoard: {
            BoardID: null,
            BoardName: "",
            InstituteType: null,
            StateID: "00000000-0000-0000-0000-000000000000"
          }
        },
        UserLoanDocuments: {
          AddharCardPath: null,
          AdharCardPath: null,
          BirthCertificate: null,
          CastCertificate: null,
          CasteCertificate: null,
          CourtOrder: null,
          DeceasedID: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          FinalDuesLetter: null,
          IncomeTaxApplication: null,
          LegalHireNOC: null,
          MedicalCertificate: null,
          OtherDocument: null,
          PFDeclaration: null,
          PancardPath: null,
          PersonResolutionPath: null,
          PhotoPath: null,
          PoliceVerification: null,
          RationCardPath: null,
          RecommendationLetter: null,
          RegCopy: null,
          ResidentialProofPath: null,
          SignaturePath: null
        },
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AdharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null
        },
        UserEmergencyContact: {
          ContactName: "",
          Address: "",
          MobileNo: ""
        },
        UserOtherDetails: {
          WorkingYears: "",
          EmployerName: "",
          LoadCapcity: "",
          UnionName: "",
          AccidentHistory: "",
          MedicallyFit: "",
          CriminalCase: "",
          ToliName: "",
          ToliNumber: ""
        },
        UserReligionCaste: {
          ReligionID: "d3f6b84b-c005-474d-aff9-dd27fa763ebc",
          CategoryID: "d25679fb-92ea-434d-a0f8-65b3290c7a8b",
          ReligionName: null,
          CategoryType: null,
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: null,
          EmploymentRegNo: null,
          EmploymentExchangeStatus: false
        },
        UserDecleration: {
          UserID: "00000000-0000-0000-0000-000000000000",
          ConfirmStatus: false,
          DeclerationText: null
        },
        ApplyForJob: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          JobId: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Status: 0,
          PersonalDetail: false,
          AddressDetail: false,
          OtherDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          ApplicationNo: null
        },
        UserApplication: [],
        UserEvaluation: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          BatchID: "00000000-0000-0000-0000-000000000000",
          RunningMark: 0,
          PullUps: 0,
          Situps: 0,
          EducationalMarks: 0,
          Height: 0,
          Weight: 0,
          ChestDeflated: 0,
          ChestInflated: 0
        },
        UserDocumentReview: {
          Review: false,
          Comments: null,
          ApplicationID: "00000000-0000-0000-0000-000000000000"
        },
        UserDocumentUpload: {
          ApplicantPhotoStatus: false,
          ApplicantSignatureStatus: false,
          AdharCardStatus: false,
          RationCardStatus: false,
          DOBCertificateStatus: false,
          CasteCertificateStatus: false,
          DegreeCertificateStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AdharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: ""
        },
        UserNominee: [
          {
            NomineeID: "2ff23306-0f82-4613-8197-1aff4533d8b1",
            NomineeName: "",
            Gender: false,
            DOB: "",
            ReletionShip: 3,
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ],
        UserProfileStatus: {
          PersonalDetail: false,
          AddressDetail: false,
          PhysicalDetail: false,
          NomineeDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          FamilyDetail: false
        },
        LoanApplication: [
          {
            LoanType: "",
            UserID: "",
            LoanApplicationID: "",
            LoanApplicationNo: "",
            SchemeType: "",
            GroupID: "",
            AmountDemanded: "",
            ApplicationStatus: "",
            AmountApproved: "",
            Level1Approver: "",
            Level1ApprovalDate: "",
            Level2Approver: "",
            Level2ApprovalDate: "",
            LOIDate: "",
            BankID: "",
            BankApprovalDate: "",
            BankLoanAmount: "",
            BankInterestRate: "",
            LoanTenure: "",
            LoanStartDate: "",
            LoanEndDate: "",
            LoanStatus: ""
          }
        ],
        UserFamily: [
          {
            FamilyID: "efc2815c-68ef-4211-b804-2dde92d97522",
            FullName: "",
            Gender: false,
            DOB: "",
            ReletionShipID: "6fce0f55-2fb6-45b3-ad1f-aa6eb9cecae7",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          },
          {
            FamilyID: "026e72ee-55b9-4fd4-8a58-3e0f96a08ed4",
            FullName: "",
            Gender: true,
            DOB: "2014-06-03T00:00:00",
            ReletionShipID: "435ea13a-01f6-4360-aa7c-eabb5e4a791a",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          },
          {
            FamilyID: "413f61a2-1b95-49b9-b397-8cc53994f134",
            FullName: "",
            Gender: false,
            DOB: "1983-12-24T00:00:00",
            ReletionShipID: "f57b429f-481e-47f3-a6dd-99acc6456b56",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ]
      },
      docObj: {},
      docTbl: []
    };
  },
  methods: {
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      this.$router.push("/Eprofile");
    },
    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" + userId + "/" + pic
        );
      }
    }
  },

  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let promiseU = apis.ReadUserDetailByIndivisual(userinfo.UserId); //Personal Details

    promiseU
      .then(response => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          this.personalDetails.DOB = Formatter.convertDateFormatYMD(
            response.body.DOB   
          );
          this.personalDetails.UserLoanDocuments =
            response.body.UserLoanDocuments;
          for (var i = 0; i < response.body.LoanApplication.length; i++) {
            if (response.body.LoanApplication[i].LoanType == 2) {
              this.personalDetails.LoanApplication[0].LoanApplicationNo =
                response.body.LoanApplication[i].LoanApplicationNo;
            }
          }

          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
.p-main-container {
  padding-top: 30px;
  background-color: #fff;
  padding-bottom: 30px;
}

.p-buttons-wrap {
  width: fit-content;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
}

.p-buttons-wrap button {
  color: #fff;
  background-color: #ab7806;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
  background-color: #ab7806 !important;
  color: #fff !important;
  border: none !important;
  outline: none !important;
}

.text-primary {
  font-size: 18px;
  color: #000 !important;
  margin-bottom: 20px;
  font-weight: bold;
}

table.profile-table {
  border: 0px solid #d3d3d3;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
table.profile-table td,
table.profile-table th {
  border: 1px solid #d3d3d3;
  padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
  width: 33%;
}
table.profile-table td span.bold {
  font-weight: bold;
  font-size: 14px;
}

table.profile-table tbody td {
  font-size: 13px;
  color: #000000;
}

table.doc-table {
  width: 50%;
}

.reg-form-box .reg-form-body {
  border: none;
  padding-top: 10px;
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/RegistrationLoan/viewPresDetailDash.vue